import * as PIXI from 'pixi.js-legacy';

export default class GraphicMask extends PIXI.Rectangle {
  /**
   * @type PIXI.Graphics
   */
  mask;

  constructor(x, y, width, height) {
    super(x, y, width, height);
    this.mask = new PIXI.Graphics();
  }

  render() {
    this.mask.clear();
    this.mask.beginFill(0xffffff);
    this.mask.drawRect(this.x, this.y, this.width, this.height);
    this.mask.endFill();
  }
}
